import React from 'react'

import { CQEssentialsLogo } from 'Assets/icons/CQEssentialsLogo'
import { styled } from '@clickcease/cc-client-components-lib'

const LogoContainer = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  top: '0px',
  left: '24px',
})

export const LeftCornerLogo = () => {
  return (
    <LogoContainer>
      <CQEssentialsLogo width={'130px'} />
    </LogoContainer>
  )
}
